var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "base-search-query" } },
    [
      _vm._l(_vm.query, function (param) {
        return _c(_vm.getComponentType(param), {
          key: param.key,
          tag: "component",
          attrs: { param: param, schema: _vm.schema },
          on: {
            "delete-param": function ($event) {
              return _vm.$emit("delete-param", param)
            },
          },
        })
      }),
      _vm._v(" "),
      _vm._t("input"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }